const cartType={
START_FETCHING_CART_DETAILS: 'START_GETTING_CART_DETAILS', 
SUCCESS_FETCHIED_CART_DETAILS: 'SUCCESS_FETCHIED_CART_DETAILS' ,
FAILED_FETCHIED_CART_DETAILS: 'FAILED_FETCHIED_CART_DETAILS' ,

START_GETTING_COMPANY_DETAILS: 'START_GETTING_COMPANY_DETAILS', 
SUCCESS_FETCHIED_COMPANY_DETAILS: 'SUCCESS_FETCHIED_COMPANT_DETAILS' , 
FAILED_FETCHIED_COMPANY_DETAILS: 'FAILED_FETCHIED_COMPANT_DETAILS' , 

SET_CART_DETAILS:'UPDATE_CART_DETAILS',
SET_CART_DETAILS:'SET_CART_DETAILS',
SET_IS_COMPANY: 'SET_IS_COMPANY',
SET_IS_PERSONAL: 'SET_IS_PERSONAL',
SET_COMPANY_DETAILS: 'SET_COMPANY_DETAILS'


}

export default cartType;